const planConfig = {
  ground_control: {
    ground_control_points_plan: "Ground Control Points Plan",
    ground_control_points_plan_label: "Ground Control Points Plan",
    basePrice: 20,
    extraPrice: 5,
    max: 20,
    id: 5,
  },
  projectTypes: [
    {
      key: "photos",
      label: "Photos & Videos",
      description:
        "High-resolution aerial imagery and video for marketing and documentation.",
      icon: "📷",
    },
    {
      key: "orthomosaic",
      label: "Photogrammetry Mapping",
      description:
        "Accurate, georeferenced site maps for CAD and GIS workflows.",
      icon: "🗺️",
    },
    {
      key: "lidar",
      label: "LiDAR",
      description: "Precision laser scanning of topography and 3D structures.",
      icon: "📡",
    },
    {
      key: "modeling",
      label: "3D Modeling",
      description: "Realistic digital twins from point clouds and mesh models.",
      icon: "🏗️",
    },
    {
      key: "inspection",
      label: "Inspections",
      description:
        "Safe, efficient detection with thermal and high-resolution zoom imagery.",
      icon: "🔍",
    },
  ],
  subServices: {
    photos: [
      {
        key: "ext-photos",
        label: "Exterior Photos", //(Pins or Polygons)
        icon: "📷",
        plan: "Photos Plan",
      },
      {
        key: "int-photos",
        label: "Interior Photos", //(Polygons)
        icon: "📷",
        plan: "Photos Plan",
      },
      {
        key: "ext-videos",
        label: "Exterior Videos", // (Lines or Polygons)
        icon: "🎥",
        plan: "Videos Plan",
      },
      {
        key: "int-videos",
        label: "Interior FPV Videos", //(Polygons)
        icon: "🎥",
        plan: "Videos Plan",
      },
      {
        key: "ext-fpv-videos",
        label: "Exterior FPV Videos", //(Lines or Polygons)
        icon: "🎥",
        plan: "Videos Plan",
      },
    ],

    orthomosaic: [
      {
        key: "mapping-area",
        label: "Mapping Area", //(Polygons)
        icon: "🗺️",
        plan: "Photogrammetry Plan",
      },
      {
        key: "ground-control-orthomosaic",
        label: "Ground Control", //(Pins or Polygons)
        icon: "📍",
        plan: "Ground Control Points Plan",
      },
    ],

    lidar: [
      {
        key: "topo-scans",
        label: "Topography Scans", //(Polygons)
        icon: "📡",
        plan: "Lidar Plan",
      },
      {
        key: "3d-building-scan",
        label: "3D Building Scanning", // (Polygons)
        icon: "🏢",
        plan: "Lidar Plan",
      },
      {
        key: "ground-control-lidar",
        label: "Ground Control", // (Pins or Polygons)
        icon: "📍",
        plan: "Ground Control Points Plan",
      },
    ],

    modeling: [
      {
        key: "mesh-point-cloud",
        label: "Mesh or Point Cloud", //(Polygons)
        icon: "🌐",
        plan: "Photogrammetry Plan",
      },
      {
        key: "ground-control-modeling",
        label: "Ground Control", // (Pins or Polygons)
        icon: "📍",
        plan: "Ground Control Points Plan",
      },
    ],

    inspection: [
      {
        key: "thermal-buildings",
        label: "Thermal Imagery for Buildings", //(Polygons)
        icon: "🏠🔥",
        plan: "Photos Plan",
      },
      {
        key: "thermal-solar",
        label: "Thermal Imagery for Solar & Utility", //(Polygons)
        icon: "🔋🔥",
        plan: "Photos Plan",
      },
      {
        key: "zoom-buildings",
        label: "Zoom Imagery for Buildings", // (Polygons)
        icon: "🏢🔍",
        plan: "Photos Plan",
      },
      {
        key: "zoom-infra",
        label: "Zoom Imagery for Infrastructure", // (Polygons)
        icon: "🏗️🔍",
        plan: "Photos Plan",
      },
    ],
  },
};

export default planConfig;
